export default "__VITE_ASSET__6rVP3waw__"